import { render } from "./IconButton.vue?vue&type=template&id=2a815738&scoped=true&ts=true"
import script from "./IconButton.vue?vue&type=script&lang=ts"
export * from "./IconButton.vue?vue&type=script&lang=ts"

import "./IconButton.scss?vue&type=style&index=0&id=2a815738&scoped=true&lang=scss"
import "./IconButtonGlobal.scss?vue&type=style&index=1&lang=scss"

import exportComponent from "/var/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2a815738"]])

export default __exports__